export const DEFAULT_DENOMINATION = "AWG";
const SYMBOL_CODES: Record<string, string> = { "$": "USD", "€": "EUR", "£": "GBP", "¥": "JPY", "ƒ": "AWG" };
export function normalizeDenomination(value: unknown): string | undefined {
  if (typeof value !== "string" || value.length > 16) return undefined;
  if (SYMBOL_CODES[value]) return `${SYMBOL_CODES[value]}/${value}`;
  const parts = value.split(/\/(.*)/s, 2);
  const safeSymbol = parts.length === 1 || (/^[\p{L}\p{Sc}./]{1,8}$/u.test(parts[1]) && /[\p{L}\p{Sc}]/u.test(parts[1]));
  return /^[A-Z]{3}$/.test(parts[0]) && safeSymbol ? value : undefined;
}
export function companyDenomination(policy?: Record<string, unknown>, initial?: string): string {
  return normalizeDenomination(policy?.denomination_symbol) ?? normalizeDenomination(initial) ?? DEFAULT_DENOMINATION;
}
export function denominationCode(value?: string): string {
  return (normalizeDenomination(value) ?? DEFAULT_DENOMINATION).split("/")[0];
}
export function denominationLabel(value?: string): string {
  const normalized = normalizeDenomination(value) ?? DEFAULT_DENOMINATION;
  const separator = normalized.indexOf("/");
  return separator < 0 ? normalized : normalized.slice(separator + 1);
}
